import { JSX } from "react";
import logo from "../img/Capture Accelerator logo.png";
export { Logo };

const gitHash = REACT_APP_GIT_VERSION;

const Logo = (): JSX.Element => {
  return <img src={logo} title={gitHash} />;
};
